import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import {IElement, ITextAttributes} from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";
import {ReactComponent as BoldIcon} from 'assets/svgs/bold.svg';

const FontWeightComandOption:React.FC<IProps> = (props) => {      
    let context = useContext(Context);
    const [isSelected, setIsSelected]= useState(false);

    useEffect(() => {
      const fontWeight = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontWeight", "Text", context.editorStatus.textSelectionInformation);
      const someOneNotBold = !fontWeight;
      setIsSelected(!someOneNotBold);
    }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

    const SetFontWeight = () => {  
        setIsSelected(!isSelected);
        context.onCommandChange("fontWeight", !isSelected);          
      }

  return (
    <S.Root>
         <Tooltip tip={"Bold"}>
        <S.ButtonContainer onClick={SetFontWeight} isSelected={isSelected}>       
            <BoldIcon/>        
        </S.ButtonContainer>
        </Tooltip>
    </S.Root>
  );

}


export default FontWeightComandOption;